import React from "react";
import PropTypes from "prop-types";
import { errors } from "./Validator";
import { FormGroup, Label, Input, FormText } from "reactstrap";

/*
FormComponent Component is used display the form input fields.
*/

const FormComponent = ({
  labelClass,
  group,
  label,
  style,
  type,
  name,
  value,
  change,
  blur,
  placeholder,
  error,
  required,
  disabled,
  min,
  max,
  maxlength,
  minlength,
  length,
  fixedLength,
  index
}) => {
  return (
    <FormGroup className={group || ""}>
      {label ? <Label className={labelClass}>{label}</Label> : null}
      <Input
      tabIndex={index}
      
      onKeyDown={ (evt) =>  evt.target.type =="number" &&  evt.key === 'e' && evt.preventDefault() }
        type={type}
        name={name}
        value={value}
        style={style}
        
        className="form-control-sm"
        onChange={change}
        onBlur={blur}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        min={fixedLength}
        max={length}
        maxlength={maxlength}
        minlength={minlength}
      />

      {error && <FormText className="error">{error}</FormText>}
      {errors[name] && (
        <FormText color="unmuted" className="error">
          {errors[name]}
        </FormText>
      )}
    </FormGroup>
  );
};

FormComponent.propTypes = {
  group: PropTypes.string,
  labelClass: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputClass: PropTypes.string,
  change: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
FormComponent.defaultProps = {
  type: "text",
  labelClass: "bold",
  inputClass: "form-control",
};

export default FormComponent;
